import { isArray } from 'lodash';
import { Typography } from 'antd';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';

import {
  FormAddButton,
  FormCancelButton,
  StyledModal,
} from 'common/components';
import CustomTable from '../components/CustomTable';

import { useGetMemberId } from 'hooks';
import { useGetLocationForMember } from './queries';
import { useLocationColumns } from '../companyLocation/hook';

const AssociateLocationsModal = injectIntl((props) => {
  const { onSubmit, setVisible, visible, currentContact, loading } = props;

  const { associateLocationIds } = currentContact || {};

  const [selectedRowKeys, setSelectedRowKeys] = useState(associateLocationIds);

  const { memberId } = useGetMemberId();
  const { locationList, isLoading } = useGetLocationForMember({
    memberId: memberId,
  });

  const mappingData =
    isArray(locationList) &&
    locationList?.map((location) => {
      return {
        ...location,
        key: location?.id,
      };
    });

  const hiddenFields = ['type', 'associatedContact', 'associatedCertificates'];

  const { columns } = useLocationColumns(hiddenFields);

  const handleSubmit = async () => {
    onSubmit && onSubmit({ selectedRowKeys });
  };

  return (
    <React.Fragment>
      <StyledModal
        title='Associated Locations'
        width={1150}
        destroyOnClose
        maskClosable={false}
        visible={visible}
        onCancel={() => setVisible(false)}
        bodyStyle={{ height: 'min(500px, 50vh)' }}
        footer={[
          <FormCancelButton onClick={() => setVisible(false)} />,
          <FormAddButton
            text='Submit'
            style={{ marginLeft: 10 }}
            loading={loading}
            onClick={handleSubmit}
          />,
        ]}
      >
        {mappingData?.length > 0 ? (
          <div style={{ height: 430 }}>
            <CustomTable
              columns={columns}
              loading={isLoading}
              dataSource={mappingData}
              selectedRowKeys={selectedRowKeys}
              setSelectedRowKeys={setSelectedRowKeys}
              isMultipleSelect
            />
          </div>
        ) : (
          <EmptyView text='No locations available to link' />
        )}
      </StyledModal>
    </React.Fragment>
  );
});

export default AssociateLocationsModal;

export const EmptyView = ({ text, style }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        ...style,
      }}
    >
      <Typography.Paragraph style={{ fontSize: '18px', color: '#8c8c8c' }}>
        {text}
      </Typography.Paragraph>
    </div>
  );
};
